import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
// import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.png";
import news from "../../Assets/Projects/news.jpg";
import chatify from "../../Assets/Projects/chatify.png";
import tour from "../../Assets/Projects/tour.jpg";
import weather from "../../Assets/Projects/weather.jpg"
import course from "../../Assets/Projects/course-selling.png"
import plmwebapp from "../../Assets/Projects/plmwebapp.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plmwebapp}
              isBlog={false}
              title="PLM(Product Lifecycle Management)"
              description="A web application that provides a comprehensive solution for managing the entire lifecycle of a product, from inception to retirement. It offers features such as product data management, change management, collaboration tools, and reporting capabilities. The app streamlines processes, enhances communication among teams, and ensures compliance with industry standards."
              
              ghLink="https://github.com/Shubhanshu9696/plm-webapp"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Real-time communication protocols, with 90% reliability.
              Uses client-server architecture (1 to 1 communication).
              core features including Java, networking, multithreading, Java
              Socket class.
              This app resulting in 30% increase in user engagement."
              ghLink="https://github.com/Shubhanshu9696/java-chat-application"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>

         
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={news}
              isBlog={false}
              title="GlobeGist"
              description="A news app aggregates and delivers up-to-date news articles and headlines from various sources, covering a wide range of topics such as politics, business, technology, sports, entertainment, and more. Users can personalize their news feed based on their interests and preferences, allowing them to stay informed about the latest developments and trends. "
              ghLink="https://github.com/Shubhanshu9696/Trending-GlobeGist-App"
              // demoLink="put your link here"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="SkySage"
              description="
              A weather app provides users with real-time weather information for their current location or any location they specify. Users can view details such as temperature, humidity, wind speed, and precipitation forecast for the upcoming hours or days. Some apps may also offer additional features like weather radar, severe weather alerts, and customizable notifications. "
              ghLink="https://github.com/Shubhanshu9696/SkySage-App"
              demoLink="https://skysage-app.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tour}
              isBlog={false}
              title="WanderWay"
              description="A tour package app offers users pre-planned travel options, including destinations, activities, and pricing. Users can explore, compare, and book tours seamlessly through the app, simplifying travel planning and enhancing the overall experience."
              ghLink="https://github.com/Shubhanshu9696/City-tourism-app"
              // demoLink="wanderway-app.netlify.app"
              demoLink="https://wanderway-app.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={course}
              isBlog={false}
              title="CourseFolio"
              description="Created sophisticated courseFolio application using React, RESTful APIs, HTML, CSS, JavaScript, and Tailwind CSS. Features include category-wise search, secure payments, user reviews, and personalized recommendations. Achieved high performance with average search response time of 150 milliseconds."
              ghLink="https://github.com/Shubhanshu9696/course-selling"
              // demoLink="wanderway-app.netlify.app"
              demoLink="https://course-hub-app.netlify.app/"
            />
          </Col>


            
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}


        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
